import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { QrCode, CheckCircle2, Circle, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { Loading, fmtDT, useData } from "@/ops/ui";
import DutyPanel from "@/ops/staff/DutyPanel";

function LocationShare({ project }) {
  const [on, setOn] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    if (!on) return undefined;
    const send = () => navigator.geolocation.getCurrentPosition(
      (pos) => api.post("/ops/field/location", { project_id: project.id, lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy })
        .then(() => setMsg(`Son paylaşım: ${new Date().toLocaleTimeString("tr-TR")}`)).catch(() => setMsg("Konum gönderilemedi")),
      () => setMsg("Konum izni verilmedi; konum kaydedilmiyor."), { enableHighAccuracy: true, timeout: 15000 });
    send();
    const t = setInterval(send, project.location_interval_min * 60000);
    return () => clearInterval(t);
  }, [on, project]);
  return (
    <label className="mt-3 flex items-start gap-2 rounded-md bg-zinc-50 p-3 text-sm">
      <input type="checkbox" checked={on} onChange={(e) => setOn(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[color:var(--red)]" data-testid={`location-share-${project.id}`} />
      <span><MapPin className="mr-1 inline h-4 w-4 text-[color:var(--red)]" />Görev süresince konumumu {project.location_interval_min} dakikada bir paylaş <span className="block text-xs text-zinc-500">{msg || "Yalnızca bu ekran açıkken çalışır."}</span></span>
    </label>
  );
}

export default function StaffHome() {
  const [d] = useData("/ops/field/projects");
  if (!d) return <Loading />;
  return (
    <div className="mx-auto max-w-2xl">
      <p className="text-sm text-zinc-500">Sicil: {d.employee.sicil_no}</p>
      <h1 className="mb-4 text-2xl font-extrabold" data-testid="ops-page-title">Görevlerim</h1>
      <Link to="/operasyon/tara" className="btn-red mb-6 w-full justify-center !py-4 text-lg" data-testid="staff-scan-btn"><QrCode className="h-6 w-6" /> QR Kod Okut</Link>
      {d.projects.length > 0 && <DutyPanel projects={d.projects} />}
      {!d.projects.length && <p className="rounded-lg border border-dashed border-zinc-300 bg-white p-6 text-center text-sm text-zinc-500" data-testid="staff-no-projects">Size atanmış aktif proje yok. Yöneticinize başvurun.</p>}
      {d.projects.map((p) => {
        const done = Object.fromEntries(p.my_scans_today.map((s) => [s.checkpoint_id, s]));
        return (
          <div key={p.id} className="mb-4 rounded-lg border border-zinc-200 bg-white p-4" data-testid={`staff-project-${p.id}`}>
            <h2 className="font-bold">{p.name}</h2>
            <p className="text-xs text-zinc-500">{p.address}{p.photo_required && " · Fotoğraf zorunlu"}</p>
            <ul className="mt-3 divide-y divide-zinc-100">
              {p.checkpoints.map((c) => (
                <li key={c.id} className="flex items-center justify-between py-2 text-sm">
                  <span className="flex items-center gap-2">{done[c.id] ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <Circle className="h-4 w-4 text-zinc-300" />}{c.order}. {c.name}{c.photo && <span className="ml-1 text-xs text-[color:var(--red)]">(fotoğraf)</span>}</span>
                  <span className="text-xs text-zinc-500">{done[c.id] ? `Son: ${fmtDT(done[c.id].at)}` : "Bugün okutulmadı"}</span>
                </li>
              ))}
            </ul>
            {p.location_interval_min > 0 && <LocationShare project={p} />}
          </div>
        );
      })}
    </div>
  );
}
